import dayjs from "dayjs";
import Cookies from "js-cookie";

import { Role } from "@/store/apis";
import { LoginDriver, LoginExped } from "@/store/apis/nextcargo";

import { createAppSlice } from "../../utils";
import { SessionState } from "./auth.types";

const initialState: SessionState = {
  driver: null,
  expedition: null,
  isAuthenticated: false
};

export const authSlice = createAppSlice({
  name: "auth",
  initialState,
  reducers: (create) => ({
    setExpeditionCredentials: create.preparedReducer(
      (body: LoginExped["result"]) => ({
        payload: {
          ...body,
          // "DD/MM/YYYY [às] HH:mm:ss"
          timestamp: dayjs().valueOf()
        }
      }),
      (state, { payload }) => {
        return {
          ...state,
          expedition: payload,
          isAuthenticated: !!payload.accessToken
        };
      }
    ),
    setExpeditionTimestamp: create.reducer((state) => {
      if (!state.expedition) return state;

      return {
        ...state,
        expedition: {
          ...state.expedition,
          timestamp: dayjs().valueOf()
        }
      };
    }),
    setDriverCredentials: create.preparedReducer(
      ({ name, ...body }: LoginDriver["result"]) => {
        const normalizedName = name
          .replace(/"/g, "")
          .replace(/^[\s\t]+/, "")
          .trim();

        return {
          payload: { ...body, name: normalizedName, role: Role.Motorista }
        };
      },
      (state, { payload }) => {
        return {
          ...state,
          driver: payload,
          isAuthenticated: !!payload.accessToken
        };
      }
    ),
    logout: create.reducer((state) => {
      Cookies.remove("userTerm", { path: "/" });
      sessionStorage.clear();
      localStorage.clear();

      Object.assign(state, { driver: null, expedition: null, isAuthenticated: false });
    })
  }),
  selectors: {
    selectSession: (state) => state,
    selectDriverSession: (state) => state.driver,
    selectExpeditionSession: (state) => state.expedition
  }
});

export const authSliceActions = authSlice.actions;
export const authSliceSelectors = authSlice.selectors;
